/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_For_Whom_DescriptionInputs */

const en_seo_for_whom_description = /** @type {(inputs: Seo_For_Whom_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For personal trainers, studios and clubs, dieticians and physios: bookings, plans, meal plans, payments and your team in one app.`)
};

const pl_seo_for_whom_description = /** @type {(inputs: Seo_For_Whom_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dla trenerów personalnych, studiów i klubów, dietetyków i fizjoterapeutów: rezerwacje, plany, jadłospisy, płatności i zespół w jednej aplikacji.`)
};

/**
* | output |
* | --- |
* | "For personal trainers, studios and clubs, dieticians and physios: bookings, plans, meal plans, payments and your team in one app." |
*
* @param {Seo_For_Whom_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const seo_for_whom_description = /** @type {((inputs?: Seo_For_Whom_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_For_Whom_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_seo_for_whom_description(inputs)
	return en_seo_for_whom_description(inputs)
});